export function convertDate(date: string) {
	const newDate = new Date(date)

	const months = [
		'Jan',
		'Fev',
		'Mar',
		'Abr',
		'Mai',
		'Jun',
		'Jul',
		'Ago',
		'Set',
		'Out',
		'Nov',
		'Dez',
	]

	const day = newDate.getDate()
	const month = months[newDate.getMonth()]
	const year = newDate.getFullYear()

	const formattedDate = `${day
		.toString()
		.padStart(2, '0')} de ${month}. de ${year}`

	return formattedDate
}
